// Libraries
import { QueryResult } from "@apollo/client";
// API

import { useGetGroupsListQuery, GetGroupsListQuery } from "generated/graphql";
// Utils
import { getBUFromLocalStorage } from "helpers/storage";
import { useStateSpecies } from "./useStateSpecies";

interface UseGetGroupsParams {
  forAllSpecies?: boolean;
}

type UseGetGroups = (params?: UseGetGroupsParams) => UseGetGroupsReturn;

export type GroupType = NonNullable<
  NonNullable<NonNullable<NonNullable<GetGroupsListQuery>["groupsExtended"]>["groups"]>[0]
>;

interface UseGetGroupsReturn extends QueryResult {
  data: GroupType[];
}

export const useGetGroups: UseGetGroups = ({ forAllSpecies } = {}) => {
  const { active: speciesActive } = useStateSpecies();

  const { data, ...rest } = useGetGroupsListQuery({
    variables: {
      businessUnitId: getBUFromLocalStorage(),
      animalTypeIds: !forAllSpecies && speciesActive ? [+speciesActive.id] : null,
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const groups = (data?.groupsExtended?.groups?.filter((group): group is NonNullable<typeof group> => group != null) ||
    []) as GroupType[];

  return {
    data: groups,
    ...rest,
  };
};
